type SilhouetteIconProps = {
    className?: string;
    color: string;
    size: number;
};

function SilhouetteIcon(props: SilhouetteIconProps) {
    const color = props.color || '#000';
    const size = props.size || 32;
    return (
        <span className={`d-inline-block ${props.className || ''}`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"  style={{fill: color, width: size}}>
                <path d="M416,320h-32c-35.344,0-64-28.656-64-64v-4.031c29-34.219,48-85.922,48-123.969C368,66.141,352,0,256,0S144,66.141,144,128
                    c0,38.047,19.016,89.734,48,123.953V256c0,35.344-28.656,64-64,64H96c0,0-58,16-96,96v64c0,17.688,14.313,32,32,32h448
                    c17.688,0,32-14.312,32-32v-64C474,336,416,320,416,320z"/>
            </svg>
        </span>
    );
}

export {SilhouetteIcon};
